import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingAddBankAccountSubmittedProps = EventProps

/**
 * @event onboarding_add_bank_account_submitted
 * @description Emitted when bank account details are successfully submitted during onboarding.
 */
export const OnboardingAddBankAccountSubmittedAnalytics = createAnalyticsStatic<OnboardingAddBankAccountSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_ADD_BANK_ACCOUNT_SUBMITTED,
)

export default OnboardingAddBankAccountSubmittedAnalytics
